<template>
  <m-button
    class="icon-button"
    :class="{ 'round-icon-button': round }"
    @click="$emit('click')"
  >
    <slot></slot>
  </m-button>
</template>

<script>
import MButton from '@/components/buttons/MButton'

export default {
  components: { MButton },
  props: {
    round: Boolean
  }
}
</script>

<style scoped>
.icon-button { align-items: center; display: flex; flex-shrink: 0; height: 40px; justify-content: center; width: 40px; }
</style>



// WEBPACK FOOTER //
// src/components/buttons/IconButton.vue